//
import { RFormFields } from '@/components/reusable_components/next'

//
import GUserModel from '@/models/General/GUser'
import SlCustomerModel from '@/models/Sale/SlCustomer'

//
export default RFormFields
	.from([
		{
			name: 'dte_number',
			type: 'text-field',
			props: {
				label: 'Folio'
			},
		},
		{
			name: 'dte_type',
			type: 'text-field',
			props: {
				label: 'Tipo'
			},
		},
		{
			name: 'seller_rut',
			type: 'rut-field',
			props: {
				label: 'Rut Vendedor'
			},
		},
		{
			name: 'g_seller_user_id',
			type: 'autocomplete-model',
			props: {
				itemText: 'hr_employee_full_name',
				itemValue: 'id',
				label: 'Vendedor',
				model: GUserModel,
				noObject: true,
				paramFilter: {
					is_ground_seller: 'true',
				},
			},
		},
		{
			name: 'customer_rut',
			type: 'rut-field',
			props: {
				label: 'Rut Cliente'
			},
		},
		{
			name: 'sl_customer_id',
			type: 'autocomplete-model',
			props: {
				itemText: 'business_name',
				itemValue: 'id',
				label: 'Cliente',
				model: SlCustomerModel,
				noObject: true,
			},
	    trigger(ctx) {
	      ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
	      ctx.$forceUpdate()
	    },
		},
	  {
	    name: 'sl_customer_branch_offices_id',
	    type: 'select',
	    props: {
	      label: 'Sucursal',
	      items: [],
	      itemText: 'address',
	      itemValue: 'id',
	      noObject: true,
	    },
	  },
		{
			name: 'sale_datetime',
			type: 'date-field',
			props: {
				label: 'Fecha'
			},
		},
		{
			name: 'sale_datetime_min',
			type: 'date-field',
			props: {
				label: 'Desde'
			},
		},
		{
			name: 'sale_datetime_max',
			type: 'date-field',
			props: {
				label: 'Hasta'
			},
		},
		{
			name: 'status',
			type: 'select',
			props: {
				items: [
					'Abonado',
					'Atrasado',
					'Boleta Anulada',
					'Esperando Lote',
					'Factura Anulada',
					'Pagado',
					'Pendiente',
					'Por Despachar',
					'Por Facturar',
					// 'Por Pagar',
					'Solicitud Anulada',
					'Vale Venta',
					'Venta Anulada',
				],
				label: 'Estado',
				multiple: true,
			},
		},
	])